import React, {memo} from 'react';
import {Button, FlickrIcon} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';
import PrivacyPolicyButton, {PrivacyPolicyButtonProps} from './PrivacyPolicyButton';

const Flickr = ({
  pending,
  privacyPolicyUrl,
  onClick,
}: {
  pending: boolean;
  onClick: (event: React.MouseEvent) => void;
} & PrivacyPolicyButtonProps) => {
  const {t} = useTranslation(['assetservices']);

  return (
    <>
      <Button
        onClick={onClick}
        label={!pending ? t('str_ButtonConnectToFlickr') : t('*:str_TitlePleaseWait')}
        buttonStyle={'distinct'}
        startIcon={<FlickrIcon />}
        disabled={pending}
      />
      <PrivacyPolicyButton privacyPolicyUrl={privacyPolicyUrl} />
    </>
  );
};

export default memo(Flickr);
